import { PaletteType } from '@material-ui/core';

export const palette = {
  type: 'light' as PaletteType,
  common: {
    black: '#000',
    white: '#fff',
  },
  default: {
    main: '#fff',
    contrastText: '#090E0A',
  },
  primary: {
    main: '#8EB12A',
    contrastText: '#fff',
  },
  secondary: {
    main: '#fff',
    contrastText: '#000688',
  },
  error: {
    main: '#FF5C5C',
    contrastText: '#fff',
  },
  warning: {
    main: '#0916D6',
    contrastText: '#fff',
  },
  info: {
    main: '#DBDDFF',
    contrastText: '#000688',
  },
  success: {
    main: '#4caf50',
    contrastText: '#fff',
  },
  text: {
    primary: '#8EB12A',
    secondary: '#fff',
    error: '#990000',
    warning: '#0916D6',
    info: '#0078D7',
    success: '#4caf50',
  },
  background: {
    default: '#090E0A',
    paper: '#151F16',
    element: '#CBD0D4',
  },
  gradient: {
    primary: '#fff',
    info: 'linear-gradient(120deg, #fff170, #7C85FF)',
  },
};
